"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  var cardWidth = "210px";
  return {
    card: {
      maxWidth: cardWidth,
      width: "100%"
    },
    asset: {
      display: "block",
      height: "100%",
      width: "100%"
    },
    container: {
      alignItems: "center",
      background: "rgba(0,0,0,.05)",
      display: "flex",
      justifyContent: "center",
      margin: theme.spacing(-2, -2, 0),
      maxHeight: cardWidth,
      minHeight: cardWidth,
      overflow: "hidden",
      position: "relative"
    },
    assetLabel: {
      background: theme.palette.action.active,
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.primary.contrastText,
      cursor: "default",
      fontSize: ".85rem",
      padding: theme.spacing(0.5),
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1)
    },
    statusAndLabel: {
      alignItems: "center",
      display: "flex",
      flexGrow: "1",
      maxWidth: "calc(100% - 24px)"
    },
    name: {
      fontSize: ".9rem"
    },
    info: {
      color: theme.palette.grey[600]
    },
    labelAndInfo: {
      alignItems: "center",
      display: "flex",
      margin: theme.spacing(1, -1, -2),
      width: "calc(100% + 16px)"
    },
    inTooltip: {
      color: theme.palette.primary.contrastText
    },
    statusDot: {
      marginRight: theme.spacing(0.5)
    }
  };
};

exports.styles = styles;